var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},[_c('flickity',{ref:"flickity",staticClass:"flickity",attrs:{"options":_vm.flickityOptions}},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"carousel-cell"},[_c('img',{staticClass:"carousel-img",attrs:{"src":item.imgSrc}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }